<template>
  <div>
    <el-dialog title="就诊记录" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="800px" v-if="formVisible">
      <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
        <div class="reimbursement">
          <div class="treatment-box">
            <div class="title-desc">就诊记录</div>
            <div class="tdesc w2">治疗时间：{{form.createdTime}} {{form.therapyStatus?'治疗结束':'治疗中'}}</div>
            <div class="tdesc w2">复诊时间：{{form.nextTime}}</div>
            <template v-if="form.diagnosticMode != 3">
              <div class="tdesc w2">皮肤镜：{{form.userArchives && form.userArchives.name}} {{form.createdTime}}</div>
              <div class="tdesc w2 look" @click="handleShowRecord" v-if="form.userArchives">查看记录</div>
            </template>
            <div class="tdesc w2">描述：{{form.processingScheme}}</div>
            <div class="title-desc">图片</div>
            <div v-if="form.processingUrl">
              <el-image class="banner-box" v-for="(item,index) in form.processingUrl && form.processingUrl.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
            </div>
            <div class="title-desc">其他</div>
            <div class="record-item">推荐药物：{{form.recommendedMedicine}}</div>
            <div class="record-item">疾病特征：{{form.diseaseAttribute}}</div>
            <div class="record-item">养护建议：{{form.processingScheme}}</div>
            <div class="record-item">方案优势：{{form.advantages}}</div>
            <div class="record-item">患者解惑：{{form.disabuse}}</div>
            <div class="record-item">使用方法：{{form.useMethod}}</div>

          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="formVisible = false">退出</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <dermoscopy ref="dermoscopy" />
  </div>
</template>
<script>
import TechnicalManage from '@/views/export/list/technicalManage.vue'
import dermoscopy from './dermoscopy.vue'
function initFormBean() {
  const formBean = {
  }
  return formBean
}

export default {
  components: { dermoscopy, TechnicalManage },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
      }
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 150;
  },
  methods: {
    handleShow(item) {
      this.form = item
      this.formVisible = true
    },
    handleShowRecord() {
      this.$refs.dermoscopy.handleShow(this.form)
    }
  }
}
</script>
<style lang="scss" scoped>
.treatment-box {
  background-color: #eeeded;
  padding: 16px 28px;
  margin-bottom: 14px;
  .title-desc {
    font-size: 14px;
    color: #000;
    padding-bottom: 15px;
  }
  .tdesc {
    font-size: 14px;
    color: #606266;
    padding-bottom: 12px;
    &.look {
      color: #4680e3;
      cursor: pointer;
    }
    &.w2 {
      width: 49%;
      display: inline-block;
    }
  }
  .record-item {
    font-size: 14px;
    color: #606266;
    padding: 12px 8px;
    background: #fff;
    margin-bottom: 5px;
    width: 480px;
    span {
      color: #4680e3;
      cursor: pointer;
      float: right;
    }
  }
}
.mt {
  margin-top: 10px;
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}

::v-deep.el-tabs {
  height: 100%;
  .el-tabs__content {
    height: 100%;
    overflow-y: auto;
    padding-bottom: 15px;
  }
}
.rig-btn {
  float: right;
}
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.reimbursement {
  padding: 0 20px;
}
.flexs {
  display: flex;
  align-items: center;
  .el-radio {
    margin-left: 5px;
  }
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
.banner-box {
  width: 50px;
  height: 50px;
  margin: 2px;
}
</style>
